// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/PlusButton/PlusButton.less
// module id = 1031
// module chunks = 0